





import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { AppComponent } from './app.component';
import { DropdownModule } from 'ng2-bootstrap/dropdown';
import { TabsModule } from 'ng2-bootstrap/tabs';
import { NAV_DROPDOWN_DIRECTIVES } from './shared/nav-dropdown.directive';
 
 
 
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/sidebar.directive';
import { AsideToggleDirective } from './shared/aside.directive';
import { BreadcrumbsComponent } from './shared/breadcrumb.component';

// Routing Module
import { AppRoutingModule } from './app.routing';

// Layouts
import { AgencyLayoutComponent } from './layouts/agency-layout.component';
import { FullLayoutComponent } from './layouts/full-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';

// auth
import { HttpModule } from '@angular/http';
import { FormsModule }    from '@angular/forms'; 
// used to create fake backend 
 
//import { LoginComponent } from './login/login.component';
//import { RegisterComponent } from './register/register.component'; 
// used to create fake backend
//import { fakeBackendProvider } from './_helpers/index';
//import { MockBackend, MockConnection } from '@angular/http/testing';
//import { BaseRequestOptions } from '@angular/http';
 
 

import { AuthGuard } from './_guards/index';
import { AuthenticationService } from './_Services/index';
import { Globals } from './_Globals/globals';




//import { AgenciesComponent } from './agencies/agencies.component';
//import { DebtsComponent } from './debts/debts.component';
//import { CollectionsComponent } from './collections/collections.component';
//import { UsersComponent } from './users/users.component'; 
 
import { StringFilterPipe } from './_Pipes/string-filter.pipe';

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    DropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    FormsModule,
    HttpModule, 
  ],
  declarations: [ 
    AppComponent,  
    FullLayoutComponent,
    AgencyLayoutComponent,
    SimpleLayoutComponent,
    NAV_DROPDOWN_DIRECTIVES,
    BreadcrumbsComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective,
    StringFilterPipe,
    
    //AgenciesComponent,
    //DebtsComponent,
    //CollectionsComponent,
    //UsersComponent 
        
  ],
  providers: [{
    provide: LocationStrategy,
    useClass: HashLocationStrategy 
  },
  AuthGuard,
  AuthenticationService,
  Globals
  //UserService,

  // providers used to create fake backend
  //fakeBackendProvider,
  //MockBackend,
  //BaseRequestOptions
        ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts